import React from 'react';
import { ExternalLink, Github, Star } from 'lucide-react';
import { Button } from './ui/button';
import { portfolioData } from '../data/mock';

const Projects = () => {
  const { projects } = portfolioData;

  return (
    <section id="projects" className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
      <div className="container mx-auto">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="section-label">Portfolio</span>
          <h2 className="section-title">
            Featured <span className="text-accent">Projects</span>
          </h2>
        </div>

        {/* Projects Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {projects.map((project) => (
            <div
              key={project.id}
              className="rounded-2xl border overflow-hidden transition-all group"
              style={{
                background: 'var(--bg-card)',
                borderColor: 'var(--border)'
              }}
            >
              {/* Featured Badge */}
              {project.featured && (
                <div className="px-4 py-3 flex items-center justify-center gap-2" style={{ background: 'var(--accent)' }}>
                  <Star className="h-4 w-4 fill-black" style={{ color: '#000' }} />
                  <span className="font-semibold text-sm" style={{
                    color: '#000',
                    fontFamily: 'JetBrains Mono, monospace'
                  }}>Featured</span>
                </div>
              )}

              <div className="p-6">
                {/* Project Header */}
                <h3 className="text-xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                  {project.title}
                </h3>
                <p className="text-sm mb-4" style={{ color: 'var(--text-secondary)' }}>
                  {project.description}
                </p>

                {/* Highlights */}
                <ul className="space-y-2 mb-6">
                  {project.highlights.slice(0, 2).map((highlight, index) => (
                    <li key={index} className="flex items-start gap-2 text-sm" style={{ color: 'var(--text-secondary)' }}>
                      <span style={{ color: 'var(--accent)' }}>•</span>
                      <span>{highlight}</span>
                    </li>
                  ))}
                </ul>

                {/* Technologies */}
                <div className="flex flex-wrap gap-2 mb-6">
                  {project.technologies.slice(0, 3).map((tech, index) => (
                    <span
                      key={index}
                      className="px-2 py-1 rounded text-xs border"
                      style={{
                        borderColor: 'var(--border)',
                        color: 'var(--text-muted)',
                        fontFamily: 'JetBrains Mono, monospace'
                      }}
                    >
                      {tech}
                    </span>
                  ))}
                </div>

                {/* Action Button */}
                {project.github && (
                  <button
                    onClick={() => window.open(project.github, '_blank')}
                    className="action-btn-secondary w-full py-3 rounded-lg border flex items-center justify-center gap-2"
                    style={{
                      borderColor: 'var(--accent)',
                      color: 'var(--accent)',
                      fontFamily: 'JetBrains Mono, monospace'
                    }}
                  >
                    <Github className="h-4 w-4" />
                    View Code
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* View More */}
        <div className="text-center mt-12">
          <button
            onClick={() => window.open(portfolioData.personal.github, '_blank')}
            className="action-btn-secondary px-8 py-4 rounded-full border flex items-center gap-2 mx-auto font-semibold"
            style={{
              borderColor: 'var(--accent)',
              color: 'var(--accent)',
              fontFamily: 'JetBrains Mono, monospace'
            }}
          >
            <Github className="h-5 w-5" />
            More Projects
          </button>
        </div>
      </div>
    </section>
  );
};

export default Projects;
